import { ANALYTICS_SUCCESS, ANALYTICS_FAILURE } from "../constants";
import { ToastsStore } from "react-toasts";

const initialState = {
  analytics_data: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ANALYTICS_SUCCESS:
      return {
        analytics_data: action.payload,
      };
    case ANALYTICS_FAILURE:
      ToastsStore.error(action.payload);
      return {
        error: action.payload,
      };

    default:
      return state;
  }
};
